import { CarouselModal } from '@anytag/shared-molecules';
import { PostDetailsType } from '@anytag/shared-types';
import { useControlPostDetailsModal } from '@anytag/shared-hooks';
import { AnalyticsSelectedAccountInfo } from '../../../types';
import { usePreviousTemplate } from './hooks';
import { UGCPostDetails } from './UGCPostDetails';

export interface UGCPostDetailsModalProps {
  posts: PostDetailsType[];
  onRefetchList?: () => void;
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const UGCPostDetailsModal = ({ posts, onRefetchList, analyticsAccount }: UGCPostDetailsModalProps) => {
  const previousTemplateState = usePreviousTemplate();
  const { selectedPost, siblingPostId, closePost, handleClickNext, handleClickPrev } = useControlPostDetailsModal({
    posts
  });

  const handleCloseModal = () => {
    closePost();
    onRefetchList?.();
  };

  return (
    <CarouselModal
      size="xl"
      open={!!selectedPost}
      onClose={handleCloseModal}
      onClickNext={handleClickNext}
      onClickPrev={handleClickPrev}
      siblingPostId={siblingPostId}
    >
      {selectedPost ? (
        <UGCPostDetails
          id={selectedPost.id}
          onCloseModal={handleCloseModal}
          analyticsAccount={analyticsAccount}
          {...previousTemplateState}
        />
      ) : null}
    </CarouselModal>
  );
};
